import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import type { i18n } from 'i18next'

function getUserLocale(): string {
  if (!localStorage.getItem('authInfo')) {
    return 'en-US'
  }

  try {
    const authInfo = JSON.parse(localStorage.getItem('authInfo') ?? '{}')
    return authInfo?.user?.locale ?? 'en-US'
  } catch {
    return 'en-US'
  }
}

function scheduleCheck(checkFn: () => void): void {
  setTimeout(checkFn, 100)
}

function reloadTranslationsAndCheck(i18n: i18n, checkFn: () => void): void {
  const userLocale = getUserLocale()

  i18n.loadNamespaces('translation', function onNamespacesLoaded() {
    i18n
      .reloadResources(userLocale, 'translation')
      .then(function onResourcesReloaded() {
        scheduleCheck(checkFn)
      })
      .catch(function onError(err: Error) {
        console.error('Error loading translations:', err)
      })
  })
}

export function useTranslationLoader(): boolean {
  const { i18n } = useTranslation()
  const [translationsLoaded, setTranslationsLoaded] = useState(false)

  useEffect(() => {
    function checkTranslations(): void {
      if (i18n.exists('TABLE_TH_NAME') && i18n.t('TABLE_TH_NAME') !== 'TABLE_TH_NAME') {
        setTranslationsLoaded(true)
      } else {
        reloadTranslationsAndCheck(i18n, checkTranslations)
      }
    }

    function handleLoaded(): void {
      scheduleCheck(checkTranslations)
    }

    function onLoaded(): void {
      console.log('Translations loaded')
      handleLoaded()
    }

    function onLanguageChanged(): void {
      console.log('Language changed')
      handleLoaded()
    }

    checkTranslations()

    i18n.on('loaded', onLoaded)
    i18n.on('languageChanged', onLanguageChanged)

    return () => {
      i18n.off('loaded', onLoaded)
      i18n.off('languageChanged', onLanguageChanged)
    }
  }, [i18n])

  return translationsLoaded
}

export default useTranslationLoader
